export function absoluteHref(searchBaseUrl: string, path: string): string {
  const base = searchBaseUrl.replace(/\/+$/, "")
  const normalizedPath = path.startsWith("/") ? path : `/${path}`
  return `${base}${normalizedPath}`
}
